const OrderList = () => import('@/views_pica/orders/OrderList')
const OrderDetail = () => import('@/views_pica/orders/OrderDetail')

export default [
    {
        path: 'manage/orders',
        component: {
            render(c) {
                return c('router-view')
            },
        },
        children: [
            {
                path: '',
                name: 'orderList',
                component: OrderList,
                meta: {
                    label: 'Orders',
                    title: 'Orders',
                    perms: ['menu.orders'],
                    breadcrumb: {
                        text: 'Orders'
                    }
                },
            },
            {
                path: ':orderId([0-9]+)',
                name: 'orderDetail',
                component: OrderDetail,
                meta: {
                    label: 'Order detail',
                    breadcrumb: (context) => {
                        const orderId = context.route.params.orderId
                        return [
                            {
                                to: { name: 'orderList' },
                                text: 'Orders'
                            },
                            {
                                text: `Order #${orderId}`
                            }
                        ]
                    }
                },
            },
        ]
    },
]